import { DOM_IDS, QUERY_SELECTORS } from '../utils/constants';
export default function loadResubContainer({
  unsubscribedFromAll
}) {
  if (unsubscribedFromAll) {
    const resubContainer = document.getElementById(DOM_IDS.globalResubContainer);
    if (resubContainer) {
      resubContainer.style.display = 'unset';
    }
    const resubButtonContainer = document.querySelector(QUERY_SELECTORS.resub);
    if (resubButtonContainer) {
      resubButtonContainer.style.display = 'none';
    }
    const resubButton = document.getElementById(DOM_IDS.globalresubButton);
    if (resubButton) {
      resubButton.style.display = 'none';
    }
  }
}